import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import {
  OfferTable,
  OfferTableFilters,
  useDefaultRltOfferListRequest,
} from "@/services/backend/rlt/offers/components/offer-table";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import t from "@/lang/lang";
import { CreateOfferDialog } from "@/services/backend/rlt/offers/components/create-offer-dialog";

export function OfferIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();

  const [request, setRequest] = useState(
    useDefaultRltOfferListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  const renderCalculationLink = useCallback(
    (calculationId: string, children: ReactNode) => (
      <NavLink to={`../calculations/${calculationId}`}>{children}</NavLink>
    ),
    [],
  );

  const renderOfferLink = useCallback(
    (offer: { id: string; processId: string | null }, children: ReactNode) =>
      offer.processId === processId ? (
        <NavLink to={offer.id}>{children}</NavLink>
      ) : (
        <NavLink to={`/processes/rlt/${offer.processId}/offers/${offer.id}`}>
          {children}
        </NavLink>
      ),
    [processId],
  );

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Angebote")}</MilestonePageTitle>
      </MilestonePageHeader>
      <MilestonePageContent>
        <div className="grid gap-2">
          <div className="flex justify-between">
            <OfferTableFilters request={request} onRequestChange={setRequest} />
            <CreateOfferDialog
              processId={processId!}
              onCreated={(id) => navigate(id)}
              renderCalculationLink={renderCalculationLink}
              renderOfferLink={renderOfferLink}
            />
          </div>
          <OfferTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
          />
        </div>
      </MilestonePageContent>
    </MilestonePage>
  );
}
